<template>
  <div :class="$utils.isMobile() ? 'cpt-advantages-m' : 'cpt-advantages'">
    <img class="img" src="../assets/service-bg4.png" alt="">
    <div class="advantages">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ advantagesData.titleEn }}</div>
      <div class="title tit">{{ advantagesData.title }}</div>
      <cpt-divider :type="1"></cpt-divider>
      <div class="content">
        <div class="item" v-for="item in advantagesData.list" :key="item.id">
          <div class="border-box">|</div>
          <div :class="$i18n.locale == 'en-US' ? 'text-en' : 'text'">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cptDivider from './cpt-divider.vue';
export default {
  name: 'cpt-advantages',
  components: {
    cptDivider
  },
  data() {
    return {
      advantagesData: this._contentData.advantagesData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-advantages{
  width: auto;
  position: relative;
  display: flex;
  .img{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .advantages{
    width: 100%;
    height: 100%;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 80px 0;
    .tit-en{
      color: rgba(255, 255, 255, 0.3);
      // text-align: center;
    }
    .tit{
      color: rgba(255, 255, 255, 1);
      // text-align: center;
    }
    .content{
      width: 860px;
      background: rgba(64, 126, 160, 0.8);
      display: flex;
      flex-wrap: wrap;
      padding: 50px 140px;
      margin-top: 50px;
      .item{
        display: flex;
        align-items: flex-start;
        // flex-wrap: wrap;
        width: 50%;
        font-size: 26px;
        color: #fff;
        // font-family: MiSans-Medium;
        padding: 25px 30px;
        box-sizing: border-box;
        .border-box{
          font-size: 26px;
          margin-right: 20px;
        }
        .text{
          font-size: 26px;
          color: #fff;
          // font-family: MiSans-Medium;
        }
        .text-en{
          font-size: 20px;
          color: #fff;
          // font-family: MiSans-Medium;
        }
      }
    }
  }
}
.cpt-advantages-m{
  width: auto;
  position: relative;
  display: flex;
  .img{
    width: 100%;
    height: 215px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .advantages{
    width: 100%;
    height: 100%;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px 15px;
    .tit-en{
      color: rgba(255, 255, 255, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }
    .content{
      // width: 860px;
      background: rgba(64, 126, 160, 0.8);
      display: flex;
      flex-wrap: wrap;
      padding: 15px 10px;
      .item{
        display: flex;
        align-items: flex-start;
        // flex-wrap: wrap;
        width: 50%;
        font-size: 26px;
        color: #fff;
        // font-family: MiSans-Medium;
        padding: 7px 10px;
        box-sizing: border-box;
        .border-box{
          // width: 2px;
          height: 10px;
          // background: #fff;
          margin-right: 10px;
          font-size: 10px;
        }
        .text{
          font-size: 10px;
          color: #fff;
          // font-family: MiSans-Medium;
        }
        .text-en{
          font-size: 8px;
          color: #fff;
          // font-family: MiSans-Medium;
        }
      }
    }
  }
}
</style>